module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"time":"Time"},"al":{"time":"Ora"}}')
  delete Component.options._Ctor
}
